import * as React from "react";
import * as _ from "lodash";
import { SearchableDropdownItem } from './constants';
import { MainContainer, LabelContainer, InputIcon, SuggestLabel } from './styles';
import { FilterSuggestDrawer } from './FilterSuggestDrawer';
import InnerLoader from 'components/Loading';
import { ReactComponent as ArrowIcon } from '@assets/svgs/search_arrow.svg'
import { conformsTo } from "lodash";

export interface SearchableDropdownProps {
    selectedOption?: SearchableDropdownItem;
    value: string
    options: SearchableDropdownItem[] | undefined
    isLoading: boolean
    canLoadMoreOptions?: boolean
    emptyText: string
    placeholder: string
    readonly?: boolean
    notSearchable?: boolean
    dismissAfterSelection?: boolean

    onValueChange: (value: string) => void
    onOptionSelected: (selectedItem: SearchableDropdownItem | string) => void
    onDrawerDismissed: () => void
    onLoadMoreOptions?: () => void
}

enum TriggerBy {
    ARROW = "ARROW",
    INPUT = "INPUT"
}

export interface SearchableDropdownState {
    triggeredBy?: TriggerBy
}

export class SearchableDropdown extends React.Component<SearchableDropdownProps, SearchableDropdownState> {
    private suggestInput?: HTMLDivElement | null;
    private inputContainer?: HTMLDivElement | null;

    constructor(props: SearchableDropdownProps) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        document.addEventListener("click", this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }

    handleClickOutside = (event: any) => {
        if (this.suggestInput && !this.suggestInput.contains(event.target)) {
            this.setState({
                triggeredBy: undefined
            })
            this.props.onDrawerDismissed();
        } else {
            event.preventDefault();
        }
    }

    onInputValueChange = (e:any) => {
        if (e && e.target) {
            this.props.onValueChange(e.target.value);
        }
    }

    onInputClicked = () => {
        if (!Boolean(this.props.readonly) && !this.state.triggeredBy) {
            this.setState({
                triggeredBy: TriggerBy.INPUT
            });
        }
    }

    onArrowClick = () => {
        if (!Boolean(this.props.readonly)) {
            if (this.state.triggeredBy && this.state.triggeredBy === TriggerBy.INPUT) {
                this.setState({
                    triggeredBy: undefined
                });
            } else {
                this.setState({
                    triggeredBy: TriggerBy.ARROW
                });
            }

        }
    }

    dismissDrawer = () => {
        this.setState({
            triggeredBy: undefined
        });
    }

    renderOptionList = () => {
        if (this.state.triggeredBy) {
            return (
                <FilterSuggestDrawer
                    value={this.props.value}
                    options={this.props.options ? this.props.options : []}
                    onOptionSelected={this.onOptionSelected}
                    onValueChange={this.onInputValueChange}
                    emptyText={this.props.emptyText}
                    isLoading={this.props.isLoading}
                    containerDiv={this.inputContainer}
                    dismissDrawer={this.dismissDrawer}
                    onScrollNearBottom={this.props.onLoadMoreOptions}
                    canLoadMore={this.props.canLoadMoreOptions}
                    notSearchable={this.props.notSearchable}
                    shouldShowOptions={this.state.triggeredBy === TriggerBy.ARROW || (this.state.triggeredBy === TriggerBy.INPUT )}
                />
            )
        }
        return null;
    }

    onOptionSelected = (option: string | SearchableDropdownItem) => {
        this.setState({
            triggeredBy: undefined
        }, () => {
            this.props.onOptionSelected(option)
        })
    }

    renderInput = () => {
        return (
            <LabelContainer
                readonly={this.props.readonly}
                ref={(node) => this.inputContainer = node}
            >
                <SuggestLabel
                    onClick={this.onInputClicked}
                >
                    {
                        this.props.selectedOption ? this.props.selectedOption.displayName : this.props.placeholder
                    }
                </SuggestLabel>
                <InputIcon onClick={this.onArrowClick}>
                    <ArrowIcon />
                </InputIcon>
            </LabelContainer>
        )
    }

    render() {
        if (this.props.isLoading && !this.props.options) {
            return (<InnerLoader />);
        } else {
            return (
                <MainContainer ref={(node) => this.suggestInput = node}>
                    {
                        this.renderInput()
                    }
                    {
                        this.renderOptionList()
                    }
                </MainContainer>
            );
        }
    }
}
